import { type TDiscount, DiscountCodeType } from "@./suf-store";
import { formatDiscountValue } from "apps/website/utils/i18n/currency";
import { useTranslations } from "next-intl";

/**
 * Builds the promotional banner text for a discount.
 *
 * Shared between FreshSignupFlow and DirectSalesFlow, which use the same
 * announcement keys under different namespaces.
 */
export const getAnnouncementText = (
  discount: TDiscount,
  bannerT: ReturnType<typeof useTranslations>,
  formatPrice: (value: number | string) => string,
): string => {
  const formattedDiscount = formatDiscountValue(discount, formatPrice);
  if (!formattedDiscount) {
    return bannerT("announcementFallback");
  }
  return discount.type === DiscountCodeType.ABSOLUTE_TOTAL
    ? bannerT("announcementAbsolute", { discount: formattedDiscount })
    : bannerT("announcementOff", { discount: formattedDiscount });
};
